import React, { useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import { useTranslation } from 'react-i18next'
import pathObj from '../../utils/apiPath'
import { startCase } from 'lodash'

const PropertyView = ({ setViewPropertyModal, item }) => {
  const { t } = useTranslation()
  const [property, setProperty] = useState('')
  // const [propertyAmenitiesList, setPropertyAmenitiesList] = useState('')
  const [amenities, setAmenities] = useState([])
  const fetchMasterRecords = async Amenities => {
    try {
      const payload = {}
      const path = pathObj.PropertiesMasterData
      const amenityResult = await apiGet(path, payload)
      const records = amenityResult?.data?.results
      // setPropertyAmenitiesList(records?.propertyAmenities || [])
      const amenitiesList = records?.propertyAmenities

      const amenitiesNames = []

      Amenities?.length > 0 &&
        Amenities.map(id => {
          const amenityObj = amenitiesList?.find(e => e._id === id)
          amenitiesNames.push(amenityObj.name)
          return amenityObj
        })
      setAmenities(amenitiesNames)
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }
  const getPropertyById = async () => {
    const result = await apiGet(
      `${pathObj.propertyDetailsById}?propertyId=${item?.propertyId}`
    )
    setProperty(result?.data?.results)
    fetchMasterRecords(result?.data?.results?.amenities)
  }

  useEffect(() => {
    if (item) {
      getPropertyById()
    }
  }, [])

  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <form className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('O_VIEW_USER')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setViewPropertyModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className=' border-2 rounded-md p-5'>
                  <div className='grid grid-cols-3 '>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_TYPE')}:</strong>
                      </div>
                      <div>{startCase(property?.propertyType?.name)}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_PROPERTY_CATEGORY')}:</strong>
                      </div>
                      <div>{startCase(property?.propertyCategory?.name)}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('Number of Bedrooms')}:</strong>
                      </div>
                      <div>{property?.bedrooms || 'N/A'}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('Number of Bathrooms')}:</strong>
                      </div>
                      <div>{property?.bathrooms || 'N/A'}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('Number of Living Rooms')}:</strong>
                      </div>
                      <div>{property?.livingRooms || 'N/A'}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('Number of Guest Rooms')}:</strong>
                      </div>
                      <div>{property?.guestRooms || 'N/A'}</div>
                    </div>

                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_TITLE')}:</strong>
                      </div>
                      <div>{startCase(property?.title) || 'N/A'}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('Price')}:</strong>
                      </div>
                      <div>{property?.price || 'N/A'}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('Advert Type')}:</strong>
                      </div>
                      <div>{startCase(property?.advertType) || 'N/A'}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('No. of floors')}:</strong>
                      </div>
                      <div>{property?.totalFloors || 'N/A'}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('Floor Number')}:</strong>
                      </div>
                      <div>{property?.floorNumber}</div>
                    </div>
                  </div>
                  <div className='mb-4 mt-2'>
                    <div className=''>
                      <strong>{t('Amenities')}:</strong>
                    </div>
                    <div>{amenities.join(', ') + '.' || 'N/A'}</div>
                  </div>
                  <div className='mb-4 mt-2'>
                    <div className=''>
                      <strong>{t('Description')}:</strong>
                    </div>
                    <div>{startCase(property?.description) || 'N/A'}</div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setViewPropertyModal(false)}
                >
                  {t('O_CLOSE')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default PropertyView
